import Axios from "axios";

export const getAllPizzaImages = () =>
  Axios.get(
    `https://us-central1-pizzataste-51bf2.cloudfunctions.net/getAllPizzaImages`
  );
